import React from 'react';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import ResponsiveTable from '../../ReusableComponents/ResponsiveTable';
import StatusBadge from '../../ReusableComponents/StatusBadge';
import PortalButton from './PortalButton';
import DocumentPreviewButton from './DocumentPreviewButton';
import { Status } from './Feedback';

export default function DocumentHistoryModal({ application, document, onClose }) {
  const date = value => value ? moment(value).format('DD/MM/YYYY HH:mm') : '—';
  return <Modal show onHide={onClose} size="xl" centered dialogClassName="portal-modal hidethis">
    <Modal.Header closeButton><Modal.Title>Histórico de envios · {document.requirement?.title || 'Documento'}</Modal.Title></Modal.Header>
    <Modal.Body>
      <p className="text-muted mb-3">{application.user?.name || 'Candidato'} · Os envios anteriores e suas análises são preservados para consulta.</p>
      <ResponsiveTable className="table table-striped"><thead><tr>
        <th>Arquivo</th><th>Enviado em</th><th>Situação</th><th>Análise</th><th>Justificativa</th><th>Ações</th>
      </tr></thead><tbody>
        {[document, ...(document.history || [])].map(item => <tr key={item.id}>
          <td>{item.file_name}</td><td>{date(item.created_at)}</td>
          <td><StatusBadge variant={item.id === document.id ? 'success' : 'secondary'}>{item.id === document.id ? 'Envio atual' : 'Envio anterior'}</StatusBadge>
            {item.deleted_at && <small className="d-block text-muted mt-1">Arquivado em {date(item.deleted_at)}</small>}</td>
          <td><Status value={item.status} /></td><td style={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>{item.reason || '—'}</td>
          <td><DocumentPreviewButton applicationId={application.id} documentId={item.id} /></td>
        </tr>)}
      </tbody></ResponsiveTable>
    </Modal.Body>
    <Modal.Footer><PortalButton className="btn btn-secondary" onClick={onClose}>Fechar</PortalButton></Modal.Footer>
  </Modal>;
}
